import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import JuInApp from "../app/JuInApp";
import "../app/globals.css";

const root = document.getElementById("root");

if (!root) {
  throw new Error("JuIn root element was not found.");
}

createRoot(root).render(
  <StrictMode>
    <JuInApp />
  </StrictMode>,
);
